export default [
    {
        path: '/news',
        name: 'News',
        component: () => import('@/views/news'),
        meta: {
            title: '资讯中心'
        }
    },
    {
        path: '/newsinfo/:id',
        name: 'Newsinfo',
        component: () => import('@/views/news/news-info.vue'),
        meta: {
            title: '资讯详情'
        }
    },
    {
        path: '/gather',
        name: 'Gather',
        component: () => import('@/views/gather'),
        meta: {
            title: '数位数采'
        }
    }
];
